export enum Role {
  /**
   * Administrator can add/edit data and add/edit users within a single orgnaization
   * - Sees the Administration -> Organization tab with the Users table
   * - Does not see the organization switcher
   * - Does not see the System Administration menu
   * - Edit and Update buttons are enabled
   * - Is not prompted to switch orgs when attempting to view data outside of the current org
   * - Can view/add/edit users with Administrator and User roles
   */
  Administrator = 'Administrator',

  /**
   *  Clients with limited system administrator rights can add/edit organizations, organizations groups, and users within a single product
   * - Sees the Administration -> Organization tab with the Users table
   * - Sees the organization switcher
   * - Sees the System Administration menu
   * - Edit and Update buttons are enabled
   * - Is prompted to switch orgs when attempting to view data outside of the current org
   * - Can view/add/edit users with any role except SystemAdministrator
   */
  ClientSystemAdministrator = 'Client System Administrator',

  /**
   *  Organization group administrators can add/edit data and add/edit users across multiple organizations
   * - Sees the Administration -> Organization tab with the Users table
   * - Sees the organization switcher
   * - Does not see the System Administration menu
   * - Edit and Update buttons are enabled
   * - Can view/add/edit users with any role except SystemAdministrator and ClientSystemAdministrator
   * - Is prompted to switch orgs when attempting to view data outside of the current org
   */
  OrgGroupAdministrator = 'Organization Group Administrator',

  /**
   *  Organization group users can add/edit data across multiple organizations
   * - Does not see the Administration -> Organization tab
   * - Sees the organization switcher
   * - Does not see the System Administration menu
   * - Edit and Update buttons are enabled
   * - Is prompted to switch orgs when attempting to view data outside of the current org
   */
  OrgGroupUser = 'Organization Group User',

  /**
   * Read only can view data within a single organization
   * - Does not see the Administration -> Organization tab
   * - Does not see the organization switcher
   * - Does not see the System Administration menu
   * - Edit and Update buttons are disabled
   * - Is not prompted to switch orgs when attempting to view data outside of the current org
   */
  ReadOnly = 'Read Only',

  /**
   *  System administrator can add/edit organizations, organizations groups, and users across multiple products
   * - Sees the Administration -> Organization tab with Users table
   * - Sees the organization switcher
   * - Sees the System Administration menu
   * - Edit and Update buttons are enabled
   * - Is prompted to switch orgs when attempting to view data outside of the current org
   * - Can view/add/edit users with any role
   */
  SystemAdministrator = 'System Administrator',

  /**
   * User can add/edit data within a single organization
   * - Does not see the Administration -> Organization tab
   * - Does not see the organization switcher
   * - Does not see the System Administration menu
   * - Edit and Update buttons are enabled
   * - Is not prompted to switch orgs when attempting to view data outside of the current org
   */
  User = 'User',
}
